import { useMutation, useQueryClient } from "@tanstack/react-query";

export function useCoiEnrichRun(coiId: string | undefined) {
  return useMutation({
    mutationFn: async () => {
      const r = await fetch(`/api/cois/${coiId}/enrich`, { method: "POST", credentials: "include" });
      if (!r.ok) throw new Error("Enrich failed");
      return r.json();
    },
  });
}

export function useCoiEnrichApply(coiId: string | undefined) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (fields: Record<string, unknown>) => {
      const r = await fetch(`/api/cois/${coiId}/enrich/apply`, {
        method: "POST", credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ fields }),
      });
      if (!r.ok) throw new Error("Apply failed");
    },
    onSuccess: () => { qc.invalidateQueries({ queryKey: ["coi", coiId] }); qc.invalidateQueries({ queryKey: ["cois"] }); },
  });
}
